import { render, staticRenderFns } from "./MemberCode.vue?vue&type=template&id=2a9c48d0&scoped=true&"
import script from "./MemberCode.vue?vue&type=script&lang=js&"
export * from "./MemberCode.vue?vue&type=script&lang=js&"
import style0 from "./MemberCode.vue?vue&type=style&index=0&id=2a9c48d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c48d0",
  null
  
)

export default component.exports